const tooltips = {
  szigoruszamadas: 'Annak a jelölése, hogy a bizonylat szigorú számadású-e, tehát a sorszámok egymást követik.',
  elotag: 'A Bizonylat kezdő karakterei.',
  bizonylattipus: 'A funkció célja a bizonylattípusok létrehozása, karbantartása.',
  bizonylattomb: 'A funkció célja, hogy a felhasználó létrehozhassa saját, kezelni kívánt bizonylat tömbjeit.',
};

export default function getTooltip(name) {
  return tooltips[name];
}
